import { render } from "./SecurityServices.vue?vue&type=template&id=68960af8"
import script from "./SecurityServices.vue?vue&type=script&lang=js"
export * from "./SecurityServices.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ru1x89/Sites/ssi-protection/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__